import { useEffect } from 'react';
import { useSelector, useDispatch } from 'src/redux/store';
import { fetchUnreadWhatsAppCount } from 'src/redux/slices/whatsappV2';
import useFeaturePermission from './useFeaturePermission';

/**
 * Returns the count of unread WhatsApp messages for the current practice.
 * Used by the sidebar nav to show a badge on the "WhatsApp" item.
 * Only fetches when whatsapp-messaging feature is enabled.
 *
 * Reads from state.whatsappV2.filterCounts.FOLLOW_UP_COUNT — the same source
 * used by the CommandPalette and dashboard widget (populated by
 * fetchUnreadWhatsAppCount in whatsappV2.js).
 */
export default function useWhatsappBadgeCount() {
    const dispatch = useDispatch();
    const { practiceId } = useSelector((state) => state.practiceTreatmentList);
    const { canView } = useFeaturePermission('whatsapp-messaging');
    const count = useSelector((state) => state.whatsappV2?.filterCounts?.FOLLOW_UP_COUNT || 0);

    useEffect(() => {
        if (!practiceId || !canView) return undefined;

        // Initial fetch — the thunk self-gates on practiceId + feature access
        dispatch(fetchUnreadWhatsAppCount());

        // Refresh every 5 minutes (matches TaskBadge cadence)
        const interval = setInterval(() => {
            dispatch(fetchUnreadWhatsAppCount());
        }, 5 * 60 * 1000);

        return () => clearInterval(interval);
    }, [practiceId, canView, dispatch]);

    return count;
}
